import { render } from "./ResetPasswordComponent.vue?vue&type=template&id=4c369948"
import script from "./ResetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ResetPasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/auth/ResetPasswordComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c369948"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c369948', __exports__)) {
    api.reload('4c369948', __exports__)
  }
  
  module.hot.accept("./ResetPasswordComponent.vue?vue&type=template&id=4c369948", () => {
    api.rerender('4c369948', render)
  })

}


export default __exports__